import React, { useEffect, useRef } from "react";
import { AboutSection } from "./AboutSection.js";
import { NewsletterSection } from "./NewsletterSection.js";
import { LinksSection } from "./LinksSection.js";
import { MoreSolutionsSection } from "./MoreSolutionsSection.js";
import { BottomSection } from "./BottomSection.js";
import { MobileBottomSection } from "./MobileBottomSection.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import { MobileAboutSection } from "./MobileAboutSection.js";
import { useInView } from "react-intersection-observer";

import "./Footer.scss";
import { useContent } from "contexts/contentContext/contentContext.js";

const Footer = ({ children }) => {
  const { Desktop, desktopCondition, Tablet, Mobile } = useMediaQueries();
  const { getCurrentPage } = useContent();
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "-150px",
  });
  const positionRef = useRef();

  useEffect(() => {
    if (inView) {
      document.querySelector(".download-right-side") &&
        document.querySelector(".download-right-side").classList.add("top-0");
      document.querySelector(".download-left-side") &&
        document.querySelector(".download-left-side").classList.add("top-0");
    } else {
      document.querySelector(".download-right-side") &&
        document
          .querySelector(".download-right-side")
          .classList.remove("top-0");
      document.querySelector(".download-left-side") &&
        document.querySelector(".download-left-side").classList.remove("top-0");
    }
  }, [inView]);

  //removing footer from invite page
  if (getCurrentPage() === "invite") return null;

  return (
    <div className="footer-container" ref={ref}>
      <div className="footer-top-section" ref={positionRef}>
        <Desktop>
          <MoreSolutionsSection />
        </Desktop>
        <div className="footer-top-section-end">
          <Desktop>
            <AboutSection />
            {desktopCondition ? <NewsletterSection /> : <></>}
            <div className="footer-vertical-divider"></div>
            <LinksSection />
          </Desktop>
          <Tablet>
            <MobileAboutSection />
          </Tablet>
          <Mobile>
            <MobileAboutSection />
          </Mobile>
        </div>
      </div>
      <div className="footer-horizontal-divider"></div>
      <Desktop>
        <BottomSection />
      </Desktop>
      <Mobile>
        <MobileBottomSection />
      </Mobile>
      <Tablet>
        <MobileBottomSection />
      </Tablet>
    </div>
  );
};

export default Footer;
